// Shared by the project schedule panel and the department task page - keys
// match TASK_STATUSES / DELAY_CAUSES in schedule_routes.py.

export const SCHEDULE_STATUSES = [
  { value: 'not_started', label: 'Not started' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'at_risk', label: 'At risk' },
  { value: 'delayed', label: 'Delayed' },
  { value: 'on_hold', label: 'On hold' },
  { value: 'completed', label: 'Completed' },
];

export const SCHEDULE_STATUS_LABELS = Object.fromEntries(SCHEDULE_STATUSES.map((s) => [s.value, s.label]));

export const SCHEDULE_STATUS_COLORS = {
  not_started: 'bg-gray-100 text-gray-700',
  in_progress: 'bg-blue-100 text-blue-800',
  at_risk: 'bg-amber-100 text-amber-800',
  delayed: 'bg-red-100 text-red-800',
  on_hold: 'bg-orange-100 text-orange-800',
  completed: 'bg-green-100 text-green-800',
};

// Bar fill in the Gantt, same meaning as the pills above.
export const SCHEDULE_BAR_COLORS = {
  not_started: 'bg-sky-300',
  in_progress: 'bg-blue-500',
  at_risk: 'bg-amber-400',
  delayed: 'bg-red-400',
  on_hold: 'bg-orange-400',
  completed: 'bg-green-500',
};

export const DELAY_CAUSES = [
  { value: 'client', label: 'Client' },
  { value: 'komal_internal', label: 'Komal internal' },
  { value: 'vendor', label: 'Vendor' },
  { value: 'force_majeure', label: 'Force majeure' },
  { value: 'scope_change', label: 'Scope change' },
];

// Whole days between two 'YYYY-MM-DD' strings (b - a). Parsed as UTC so the
// viewer's timezone can't shift a date-only value by a day.
export const daysBetween = (a, b) => (Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86400000;

export const formatSlip = (days) => (days > 0 ? `+${days} d` : days < 0 ? `${days} d` : 'On time');

// Project health from the PM's weekly review (green/amber/red) - kept apart
// from the purple "Monitored" marker, which only says the project is tracked.
export const HEALTH_LABELS = { green: 'Green', amber: 'Amber', red: 'Red' };

export const HEALTH_COLORS = {
  green: 'bg-green-100 text-green-800',
  amber: 'bg-amber-100 text-amber-800',
  red: 'bg-red-100 text-red-800',
};

export const HEALTH_ORDER = { red: 0, amber: 1, green: 3 }; // no health yet sorts between amber and green
